var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.90735e-06C3.58853 1.90735e-06 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 1.90735e-06 8 1.90735e-06ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23935 8 1.23935C11.728 1.23935 14.7607 4.27203 14.7607 8C14.7607 11.728 11.7273 14.7607 8 14.7607Z",
    fill: "#778797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6703 5.21766C11.4181 4.98838 11.0259 5.00635 10.7954 5.25978L7.01532 9.42216L5.18913 7.56563C4.94806 7.32147 4.55644 7.31775 4.31291 7.55819C4.06875 7.798 4.06503 8.19025 4.30547 8.43441L6.59144 10.7582C6.70857 10.8772 6.86719 10.9435 7.03326 10.9435C7.03697 10.9435 7.04132 10.9435 7.04504 10.9441C7.21607 10.9404 7.37719 10.8673 7.49182 10.7408L11.7124 6.09328C11.9424 5.83919 11.9238 5.44756 11.6703 5.21766Z",
    fill: "#778797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCheckCircle);
export default __webpack_public_path__ + "static/media/profile_check-circle.fcbd74ecaa3f49a7402fde776534e6e3.svg";
export { ForwardRef as ReactComponent };